export const config = {
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://www.streetgymprogram.com"
      : "http://localhost:4000",
  // :"https://www.streetgymprogram.com",
};
